(function () {
  function applyFilter(key) {
    const cards = document.querySelectorAll("[data-af-card]");
    let visible = 0;
    cards.forEach((card) => {
      const regions = (card.getAttribute("data-regions") || "").split(/\s+/).filter(Boolean);
      const show = key === "all" || regions.indexOf(key) !== -1;
      card.hidden = !show;
      if (show) visible += 1;
    });
    document.querySelectorAll("[data-af-empty]").forEach((empty) => {
      empty.hidden = visible !== 0;
    });
    document.querySelectorAll("[data-af-filter-button]").forEach((button) => {
      const on = button.getAttribute("data-af-filter") === key;
      button.classList.toggle("is-on", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-af-filter]");
    if (!trigger) return;
    const key = trigger.getAttribute("data-af-filter");
    if (!key) return;
    event.preventDefault();
    applyFilter(key);
    if (trigger.getAttribute("data-af-scroll") === "true") {
      const catalog = document.getElementById("catalogue");
      if (catalog) catalog.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
      const id = payload && payload.productVariantId;
      if (!id) return;
      document.querySelectorAll('[data-variant-id="' + String(id) + '"] .af-card__cta-label').forEach((label) => {
        if (label.dataset.added) label.textContent = label.dataset.added;
      });
    });
  }
})();
